import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../Context/UserContextAPI";
import formatDate from "../../utils/formatDate";
import UserInfoInReport from "../../components/Users/UserTableInReports";
const SelectedUserResult = ({ userData, onClose }) => {
  const { accessPerm } = useContext(UserContext);
  // Format birth date

  return (
    <div>
      <div className="">
        {userData ? (
          <div className="w-100 d-flex flex-column">
            <UserInfoInReport user={userData} />
            <div className="row" style={{ marginTop: "2rem" }}>
              <div className="col-sm-3 px-4">
                {accessPerm(68, 14) && (
                  <Link
                    className="btn btn-info btn-block btn-md  w-100 fw-bold"
                    to={`/medical-pathology-print/${userData?.id}`}
                    state={userData}
                    disabled={!userData?.is_pathology_done}
                    target="_blank"
                  >
                    Pathology Report
                  </Link>
                )}
              </div>
              <div className="col-sm-3 px-4">
                {accessPerm(68, 15) && (
                  <button
                    className="btn btn-info btn-block btn-md w-100 fw-bold"
                    style={{ width: "200px" }}
                    onClick={() =>
                      window.open(
                        `/medical-physical-print/${userData?.id}`,
                        "_blank",
                      )
                    }
                    disabled={!userData?.is_physical_done}
                  >
                    Physical Report
                  </button>
                )}
              </div>
              <div className="col-sm-3 px-4">
                {accessPerm(68, 13) && (
                  <button
                    className="btn btn-info btn-block btn-md w-100 fw-bold"
                    style={{ width: "200px" }}
                    onClick={() =>
                      window.open(
                        `/medical-radiology-print/${userData?.id}`,
                        "_blank",
                      )
                    }
                    disabled={!userData?.is_radiology_done}
                  >
                    Radiology Report
                  </button>
                )}
              </div>
              <div className="col-sm-3 px-4">
                {accessPerm(68, 5) && (
                  <button
                    className="btn btn-info btn-block btn-md w-100 fw-bold"
                    style={{ width: "200px" }}
                    onClick={() =>
                      // window.open(
                      //   `/medical-report-print/${selectedRowData?.user_id}`,
                      //   "_blank",
                      // )
                      window.open(
                        `/header-report-print/${userData?.id}`,
                        "_blank",
                      )
                    }
                  >
                    Medical Report
                  </button>
                )}
              </div>
            </div>
            <div className="row" style={{ marginTop: "1rem" }}>
              <div className="col-sm-3">
                {accessPerm(68, 10) && (
                  <Link
                    className="btn btn-info btn-block btn-md w-100  fw-bold"
                    style={{ width: "200px" }}
                    to={{
                      pathname: `/medical-health-card-print/${userData?.id}`,
                      state: userData,
                    }}
                    target="_blank"
                    disabled={
                      !userData?.is_physical_done &&
                      !userData?.is_pathology_done &&
                      !userData?.is_radiology_done &&
                      userData?.status === 2
                    }
                  >
                    Health Card
                  </Link>
                )}
              </div>

              <div className="col-sm-3 px-4">
                {accessPerm(68, 12) && (
                  <Link
                    to={`/medical-prescription-print/${userData?.id}`}
                    state={userData}
                    target="_blank"
                    disabled={
                      !(
                        userData?.is_radiology_done &&
                        userData?.is_pathology_done &&
                        userData?.is_physical_done &&
                        userData?.status === 4
                      )
                    }
                    className={`btn btn-info w-100 fw-bold ${
                      userData?.status === 4 ? "btn-success" : "btn-info"
                    }`}
                  >
                    Prescription
                  </Link>
                )}
              </div>

              <div className="col-sm-3 px-4">
                {accessPerm(68, 5) && (
                  <button
                    className="btn btn-info btn-block btn-md w-100 fw-bold"
                    style={{ width: "200px" }}
                    onClick={() =>
                      // window.open(
                      //   `/medical-report-print/${selectedRowData?.user_id}`,
                      //   "_blank",
                      // )
                      window.open(
                        `/without-header-report-print/${userData?.id}`,
                        "_blank",
                      )
                    }
                  >
                    Medical Report Without Header
                  </button>
                )}
              </div>

              <div className="col-sm-3 px-4">
                <button
                  className="btn btn-info btn-block btn-md w-100 fw-bold"
                  style={{ width: "200px" }}
                  onClick={() =>
                    window.open(`/kuwait-visa-print/${userData?.id}`, "_blank")
                  }
                >
                  Kuwait Visa Print
                </button>
              </div>
            </div>
          </div>
        ) : (
          <h4>No Record Available</h4>
        )}
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-warning btn-block btn-md w-25"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SelectedUserResult;
